import React from 'react';
import { GraduationCap, Award } from 'lucide-react';
import './EducationSection.css';

const EducationSection = () => {
  return (
    <section className="education-section">
      <div className="education-container">
        <div className="education-header">
          <p className="education-label">Background</p>
          <h2 className="education-title">
            <span className="gradient-text">Education</span>
          </h2>
        </div>
        
        <div className="education-cards">
          <div className="education-card glass glass-hover card-3d">
            <div className="education-card-content">
              <div className="education-icon-wrapper education-icon-primary">
                <GraduationCap size={28} />
              </div>
              <div className="education-details">
                <h3 className="education-institution">Damascus University</h3>
                <p className="education-degree">B.Sc. in Information Technology Engineering</p>
                <p className="education-major">Major: Artificial Intelligence</p>
                <div className="education-tags">
                  <span className="education-tag education-tag-secondary">2022 - Present</span>
                  <span className="education-tag education-tag-primary">Fourth Year</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="education-card glass glass-hover card-3d">
            <div className="education-card-content">
              <div className="education-icon-wrapper education-icon-secondary">
                <Award size={28} />
              </div>
              <div className="education-details">
                <h3 className="education-institution">Alsaade Secondary School</h3>
                <p className="education-major">Damascus, Syria</p>
                <div className="education-tags">
                  <span className="education-tag education-tag-secondary">2021 - 2022</span>
                  <span className="education-tag education-tag-amber">Score: 96%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
